<template>
  <div>
    <app-overlay-loader v-if="filling" />
    <div
      class="d-flex justify-content-center p-2 pl-lg-5 pr-lg-5 pt-lg-5 "
      style="background-color: whitesmoke; overflow: auto"
    >
      <VueSignaturePad
        ref="signaturePad"
        :width="signaturewidth"
        height="400px"
        :options="options"
        :customStyle="customStyle"
      />
    </div>
    <div
      class="d-flex justify-content-center p-2"
      style="
        border: 1px solid whitesmoke;
        z-index: 1;
        background-color: whitesmoke;
      "
    > 
      <app-submit-button
        class="mr-3 bg-secondary border-0 sign-btn"
        @click="undo"
        :loading="false"
        label="Clear"
      ></app-submit-button>
      <app-submit-button
        class="sign-btn"
        @click="sign"
        :loading="false"
        label="Sign"
      ></app-submit-button>
    </div>
  </div>
</template> 

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";

export default {
  name: "Sign",
  mixins: [FormMixin],
  props: {
    document: {
      type: Number,
      required: true,
    },
    recipient: {
      type: Number,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return { filling: false,
      screenWidth: 0,
      signaturewidth:'400px'
    
    };
  },
  beforeCreate() {
  String.prototype.convertToRGB = function(){
    let str = this
    if(this.startsWith("#"))  str = this.substring(1)
    if(str.split(",").length === 3) return str
    if(str.length != 6){

        throw "Only six-digit hex colors are allowed. "+str;
    }

    var aRgbHex = str.match(/.{1,2}/g);
    var aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16)
    ];
    return aRgb.join(",");
}
},
  computed: {
    options() {
      const [_, __, color] = this.field?.style.split(":");
      const colors_dict= {
        'black': '#000000',
        'green': "#008000",
        'blue': "#0000ff",
        'yellow': "#ffff00",
        'purple': "#cd5bcd",
        'orange': "#ffa500",
        'gray': "#808080"
      }

        return {
        dotSize: (0.5 + 2.5) / 2,
        minWidth: 0.5,
        maxWidth: 2.5,
        throttle: 16,
        minDistance: 5,
        backgroundColor: "transparent",
        penColor:  `rgb(${colors_dict[color].convertToRGB()})`,
        velocityFilterWeight: 0.7,
      };
    },
    customStyle() {
      return {
        border: `silver 0.5px solid`,
        backgroundColor: "white",
        borderRadius: "3px",
        boxShadow: "1px -1px 5px 2px rgba(0,0,0,0.1) inset",
      };
    },

    
    containerWidth() {
      if (this.screenWidth <= 763) {
        this.signaturewidth ='100%';
       
      } else {
        this.signaturewidth='400px';
      }
      return signaturewidth;
    },


  },

  mounted() {
    this.screenWidth = window.innerWidth;
    window.addEventListener('resize', this.resizeScreen);
    this.containerWidth='400px';

    if (this.screenWidth <= 763) {
        this.signaturewidth ='100%';
       
      } else {
        this.signaturewidth='400px';
      }

  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeScreen);
  },


  methods: {

    resizeScreen() {
      this.screenWidth = window.innerWidth;
    },

    
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    sign() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      this.filling = true;

      if (!isEmpty) {
        const formData = new FormData();
        formData.append("signature", data);
        this.axiosPost({
          url: this.url,
          data: formData,
        })
          .then((res) => {

            parent.postMessage({...res.data,"signature":data}, '*');
            window.close();

            // setTimeout(() => {
            // this.filling = false;
            // }, 30000);
          })
          .catch(() => {
            this.$toastr.e("Something wrong happen");
            this.filling = false;
          });
      } else {
        this.filling = false;
        this.$toastr.e("Signature is mandatory");
      }
    },
  },
};
</script>

<style scoped>
.sign-btn{
  width: 150px;
}
</style>
